import { authPost } from "@api";

export const postIssueSentimentFeedback = (
  feedback: string,
  deploymentId: string,
  issue_hash: string,
  sentiment: string,
  issueId: string
) => {
  return authPost<{ feedback: string; hash: string; sentiment: string }, {}>(
    `/api/agent/deployments/${deploymentId}/issues/${issueId}/sentiment/feedback`,
    {
      feedback,
      sentiment,
      hash: issue_hash,
    }
  );
};
